import ListViewCtrl from "../common/ListViewCtrl";

export default class PrevadzkovaKnihaListCtrl extends ListViewCtrl {

  static resolve = {
    dataSource: (PrevadzkovaKnihaService, FilterService, $stateParams) => PrevadzkovaKnihaService.getListSource({filter: FilterService.getFilterFromStateParams($stateParams)}).wait(),
  };

  constructor(dataSource, FilterService, $state){
    super(dataSource, FilterService);
  }


}


// WEBPACK FOOTER //
// ./src/prevadzkova-kniha/PrevadzkovaKnihaListCtrl.js